
import Vue from "vue";

export default Vue.extend({
  name: "dialog-warning",
  props: {
    isOpen: {
      type: Boolean
    }
  },
  methods: {
    goToApp() {
      window.open("badesaba//calendar", "_self");
    },
  },
});
